export default __webpack_public_path__ + "static/ntfy-b2599830d3428da8cec7cdab3d2c4d03.png";